import { memo, useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ApiStorage from '../../redux/ApiStorage';
import UserActions from '../../actions/UserActions';
import LogoSmallSVG from '../../icons/LogoSmallSVG';
import MyFlex from '../../components/myFlex/MyFlex';
import MyBadge from '../../components/badge/MyBadge';
import MySpace from '../../components/mySpace/MySpace';
import useNavigateApi from '../../appRoute/useNavigateApi';
import MyDropDown from '../../components/myDropDown/MyDropDown';
import NotificationViewModal from '../../pages/settings/notificationSettings/NotificationViewModal';
import '../mainLayout/MenuHeader.scss';

const BlockedMenuHeader = () => {
  const { t } = useTranslation();
  const navigateApi = useNavigateApi();

  const refModal = useRef(null);

  const notificationCount = useSelector((state) => {
    return state.currentUser?.notificationCount;
  });

  const companyName = useSelector((state) => {
    return state.currentUser?.companyName;
  });

  // const name = useSelector((state) => {
  //   return state.currentUser?.name;
  // });

  const handleLogOutClick = useCallback(async () => {
    await UserActions.logOut();
    ApiStorage.clearUser();
    navigateApi('/login');
  }, [navigateApi]);

  const items = useMemo(() => {
    return [
      {
        key: 'notif',
        label: notificationCount ? (
          <MySpace block spaceBetween>
            <div>{t('WORD_NOTIFICATIONS')}</div>
            <MyBadge status="error" />
          </MySpace>
        ) : (
          t('WORD_NOTIFICATIONS')
        ),
        onClick: () => {
          navigateApi(`/notification`);
        },
      },
      {
        key: 'logout',
        label: t('WORD_LOGOUT'),
        onClick: handleLogOutClick,
      },
    ];
  }, [navigateApi, notificationCount, t, handleLogOutClick]);

  return (
    <div>
      <MyDropDown
        arrow={true}
        items={items}
        placement="bottom"
        className="menu_dropdown"
      >
        <MyFlex block align="center" style={{ maxWidth: 210 }}>
          <MyBadge count={notificationCount} style={{ boxShadow: 'unset' }}>
            <LogoSmallSVG />
          </MyBadge>
          <div className="menu_header_title">{companyName}</div>
        </MyFlex>
      </MyDropDown>
      <NotificationViewModal ref={refModal} />
    </div>
  );
};

export default memo(BlockedMenuHeader);
